import { useEffect, useState } from "react";

export const SCROLL_DIRECTION = { down: "down", up: "up" };

function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState('');

  useEffect(() => {
    setScrollDirection(SCROLL_DIRECTION.up);
    // let lastScrollY = window.pageYOffset;
    //
    // const updateScrollDirection = () => {
    //   const scrollY = window.pageYOffset;
    //   const direction = scrollY > lastScrollY ? SCROLL_DIRECTION.down : SCROLL_DIRECTION.up;
    //   if (direction !== scrollDirection && Math.abs(scrollY - lastScrollY) > 0) {
    //     setScrollDirection(direction);
    //   }
    //   lastScrollY = scrollY > 0 ? scrollY : 0;
    // };
    // window.addEventListener("scroll", updateScrollDirection);
    // return () => {
    //   window.removeEventListener("scroll", updateScrollDirection);
    // };
  }, [scrollDirection]);

  return scrollDirection;
}

export default useScrollDirection;
